// NGXS
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import {
  AddOtherSettings,
  AddFacilitySetting,
  AddAllSettings,
} from '../actions/settings.action';
import {
  IOtherSetting,
  IFacilitySetting,
} from '../../models/service/other-settings.model';
import { IAllSettings } from '@models/service/all-settings.model';

// Models and interfaces

export interface SettingsStateI {
  otherSettings: IOtherSetting[];
  facilitySettings: IFacilitySetting;
  allSettings: IAllSettings;
}

@State<SettingsStateI>({
  name: 'SettingsState',
  defaults: {
    otherSettings: [],
    facilitySettings: {},
    allSettings: {}
  },
})
@Injectable({
  providedIn: 'root',
})

export class SettingsState {
  @Selector()
  static getSettingsState(state: SettingsStateI): SettingsStateI {
    return state;
  }

  @Action(AddOtherSettings)
  addOtherSettings(
    { patchState }: StateContext<SettingsStateI>,
    { payload }: AddOtherSettings,
  ): void {
    patchState({
      otherSettings: [...payload],
    });
  }

  @Action(AddFacilitySetting)
  AddFacilitySetting(
    { patchState }: StateContext<SettingsStateI>,
    { payload }: AddFacilitySetting,
  ): void {
    const facility = payload;
    // const timeZone = timeZones.find( el => el.facilityTimeZone === facility.timeZoneId);
    // facility.timeZone = timeZone.conversionTimeZone;
    patchState({
      facilitySettings: facility,
    });
  }

  @Action(AddAllSettings)
  addAllSettings(
    { patchState }: StateContext<SettingsStateI>,
    { payload: allSettings }: AddAllSettings,
  ): void {
    patchState({
      allSettings
    });
  }
}
